const attachStableStepNavigation = (builder) => {
  if (builder.dataset.stableStepNavigation === 'true') return;

  customElements.whenDefined('aura-builder').then(() => {
    requestAnimationFrame(() => {
      const root = builder.shadowRoot;
      if (!root || builder.dataset.stableStepNavigation === 'true') return;

      builder.dataset.stableStepNavigation = 'true';
      root.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('button[data-next-group]');
          const drawer = button?.closest('.pdp-build-drawer');
          if (!drawer) return;

          const scrollLeft = window.scrollX;
          const scrollTop = window.scrollY;
          const restoreViewport = () => window.scrollTo({ left: scrollLeft, top: scrollTop, behavior: 'instant' });

          drawer.scrollIntoView = () => {};
          queueMicrotask(restoreViewport);
          requestAnimationFrame(() => {
            delete drawer.scrollIntoView;
            restoreViewport();
          });
        },
        true
      );
    });
  });
};

const attachAllStableStepNavigation = (scope = document) => {
  scope.querySelectorAll('aura-builder').forEach(attachStableStepNavigation);
};

attachAllStableStepNavigation();
document.addEventListener('shopify:section:load', (event) => attachAllStableStepNavigation(event.target));

const openBuilderFromLink = (scope = document) => {
  if (new URLSearchParams(window.location.search).get('luxsol_view') !== '3d') return;

  scope.querySelectorAll('aura-builder[data-luxsol-renderer]').forEach((builder) => {
    if (builder.dataset.builderLinkHandled === 'true') return;
    builder.dataset.builderLinkHandled = 'true';

    customElements.whenDefined('aura-builder').then(() => {
      const root = builder.shadowRoot;
      if (!root) return;
      let observer;
      const open = () => {
        const control = root.querySelector('button.lx-design-cta');
        if (!control || control.disabled) return false;
        observer?.disconnect();
        // Open after the renderer has restored its saved step and initial media view.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (builder.isConnected && control.isConnected) control.click();
        }));
        return true;
      };
      if (open()) return;
      observer = new MutationObserver(open);
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    });
  });
};

openBuilderFromLink();
document.addEventListener('shopify:section:load', (event) => openBuilderFromLink(event.target));
